import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "fixed z-10 inset-0 overflow-y-auto" }
const _hoisted_2 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_3 = {
  key: 0,
  class: "fixed inset-0 transition-opacity",
  "aria-hidden": "true"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "absolute inset-0 bg-modal-overlay opacity-40" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_6 = { class: "bg-white min-w-min" }
const _hoisted_7 = { class: "sm:flex sm:items-start" }
const _hoisted_8 = { class: "text-center w-full" }
const _hoisted_9 = {
  key: 0,
  class: "text-24 font-medium text-sub-title",
  id: "modal-headline"
}
const _hoisted_10 = { class: "mt-2 text-14 text-modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.overlay)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      _hoisted_5,
      _createVNode("div", {
        class: `inline-block align-bottom bg-white rounded-md text-left overflow-hidden shadow-modal
        transform transition-all sm:my-8 sm:align-middle max-w-full ${_ctx.modalClasses} py-10 px-6`,
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "modal-headline"
      }, [
        _createVNode("button", {
          class: "absolute text-icon-light hover:text-icon-secondary text-22 top-1 right-3 focus:outline-none",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'times'] })
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              (_ctx.title)
                ? (_openBlock(), _createBlock("h3", _hoisted_9, _toDisplayString(_ctx.title), 1))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_10, [
                _renderSlot(_ctx.$slots, "default")
              ])
            ])
          ])
        ])
      ], 2)
    ])
  ]))
}